module.exports = __webpack_public_path__ + "static/img/1.900d7f80.jpg";